<template>
  <div id="app">
    <router-view></router-view>
    <div id="refline1" class="refline1"></div>
    <div id="refline2" class="refline2"></div>
    <div id="refline3" class="refline3"></div>
    <div id="refline4" class="refline4"></div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      router: 'nav'
    }
  }
}
</script>
<style>
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
body .el-table th.gutter {
  display: table-cell !important;
}
body .el-table colgroup.gutter {
  display: table-cell !important;
}
html,
body,
#app {
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}
/* umy-ui 全局影响样式 */
body {
  line-height: unset;
}
/* ::-webkit-scrollbar {
  width: 0px !important;
  height: 7px;
  background-color: #072351;
} */
.refline1 {
  position: absolute;
  bottom: 30px;
}
.refline2 {
  position: absolute;
  bottom: 15px;
}
.refline3 {
  position: absolute;
  bottom: 25px;
}
.refline4 {
  position: absolute;
  bottom: 80px;
}
.meiyu .el-table td {
  padding: 10px 0 !important;
}
.el-tooltip__popper {
  max-width: 30%;
  max-height: 800px;
  overflow-y: auto;
}
.hiddenOverflow {
  overflow-y: unset !important;
}
</style>
